import { Column } from "@/components/Column";
import { Row } from "@/components/Row";
import { Text } from "@/components/Text";
import { SadieStatDelta } from "@/components/tools/sadie-dashboard/SadieStatDelta";

import { sadieDashboardRangeToDays } from "@/lib/constants";
import { sadieDashboard } from "@/lib/sadieDashboard";
import { cn } from "@/lib/utils";
import {
  SadieDashboardRange,
  SadieDashboardStat,
  SadieStatFormat,
} from "@/types";

// The one number the page leads with: workers who are actually talking to
// Sadie, and what share of everyone she has texted that is.
export const SadieNorthStarCard = ({
  isRefreshing,
  range,
  warmRelationships,
  warmShareOfTexted,
}: {
  // Still showing the last range's numbers while a new range loads.
  isRefreshing: boolean;
  range: SadieDashboardRange;
  warmRelationships: SadieDashboardStat;
  warmShareOfTexted: SadieDashboardStat;
}) => {
  /* Helpers */
  const days = sadieDashboardRangeToDays[range].toString();
  const shareCounts = sadieDashboard.formatCounts(warmShareOfTexted);

  /* Render */
  return (
    <Row
      className={cn(
        "flex-wrap items-center justify-between gap-6 rounded-lg bg-slate-900 px-8 py-7 transition-opacity",
        isRefreshing && "opacity-60",
      )}
    >
      <Column className="gap-1.5">
        <Text className="font-plex-mono text-[10px] font-medium uppercase tracking-wider text-slate-400">
          North star
        </Text>
        <Text className="text-xl font-semibold text-white">
          Warm relationships
        </Text>
        <Text className="text-sm text-slate-300">
          Workers who replied to Sadie in the last {days} days
        </Text>
      </Column>
      <Row className="flex-wrap gap-12">
        <Column className="gap-1">
          <Text className="text-5xl font-semibold text-white">
            {sadieDashboard.formatValue(
              warmRelationships,
              SadieStatFormat.COUNT,
            )}
          </Text>
          <Text className="text-sm text-slate-300">workers right now</Text>
          <SadieStatDelta
            format={SadieStatFormat.COUNT}
            isOnDark
            range={range}
            stat={warmRelationships}
          />
        </Column>
        <Column className="justify-end gap-1">
          <Text className="text-3xl font-semibold text-white">
            {sadieDashboard.formatValue(
              warmShareOfTexted,
              SadieStatFormat.RATE,
            )}
          </Text>
          <Text className="text-sm text-slate-300">
            of workers Sadie has texted
            {shareCounts ? ` (${shareCounts})` : ""}
          </Text>
          <SadieStatDelta
            format={SadieStatFormat.RATE}
            isOnDark
            range={range}
            stat={warmShareOfTexted}
          />
        </Column>
      </Row>
    </Row>
  );
};
